import clsx from "clsx";
import { toast } from "react-toastify";

const Content = ({ title, description, toastProps }) => {
  return (
    <div>
      <div
        className={clsx("absolute h-full w-1 top-0 left-0", {
          "bg-success": toastProps.type === "success",
          "bg-info": toastProps.type === "info",
          "bg-warning": toastProps.type === "warning",
          "bg-danger": toastProps.type === "error",
        })}
      />
      <div className="text-body-3 text-neutral-900 font-bold">{title}</div>
      <div className="text-body-4 text-neutral-700">{description}</div>
    </div>
  );
};

const Notify = {
  success: (params) =>
    toast.success(
      ({ toastProps }) => (
        <Content
          title={params?.title || ""}
          description={params?.description || ""}
          toastProps={toastProps}
        />
      ),
      {
        autoClose: params?.duration || 3000, // default 3 detik
        position: "top-right",
        pauseOnHover: true,
        closeOnClick: true,
      }
    ),

  error: (params) =>
    toast.error(
      ({ toastProps }) => (
        <Content
          title={params?.title || ""}
          description={params?.description || ""}
          toastProps={toastProps}
        />
      ),
      {
        autoClose: params?.duration || 3000,
        position: "top-right",
        pauseOnHover: true,
        closeOnClick: true,
      }
    ),

  info: (params) =>
    toast.info(
      ({ toastProps }) => (
        <Content
          title={params?.title || ""}
          description={params?.description || ""}
          toastProps={toastProps}
        />
      ),
      {
        autoClose: params?.duration || 3000,
        position: "top-right",
        pauseOnHover: true,
        closeOnClick: true,
      }
    ),

  warning: (params) =>
    toast.warning(
      ({ toastProps }) => (
        <Content
          title={params?.title || ""}
          description={params?.description || ""}
          toastProps={toastProps}
        />
      ),
      {
        autoClose: params?.duration || 3000,
        position: "top-right",
        pauseOnHover: true,
        closeOnClick: true,
      }
    ),
};

export { Notify };
